<h3 *ngIf="title" class="step-card-title">{{ title }}</h3>
<p *ngIf="text" class="step-card-text" [innerHTML]="text" [ngClass]="{'next-step-card-text': variant === 'next-purina'}">
</p>
<p
  *ngIf="secondaryText"
  class="mt-1 step-card-text"
  [ngClass]="{'next-step-card-text': variant === 'next-purina'}"
>
  {{ secondaryText }}
  <a [href]="linkRedirect" [ngClass]="variant + '-step-card-link'" target="_blank">
    {{ link }}
  </a>
</p>

<a
  *ngIf="variant === 'useful'"
  [href]="linkRedirect"
  [ngClass]="variant + '-step-card-link'"
  target="_blank"
>
  {{ link }}
</a>
<button *ngIf="button" class="btn orange-button" (click)="loginRedirect()">{{ button }}</button>
